import {
  REQUEST_GET_UNDERWRITERS,
  RECEIVE_GET_UNDERWRITERS,
  ERROR_GET_UNDERWRITERS,
  REQUEST_GET_AUTHORIZED_UNDERWRITERS,
  RECEIVE_GET_AUTHORIZED_UNDERWRITERS,
  ERROR_GET_AUTHORIZED_UNDERWRITERS,
  REQUEST_ADD_INTERNET_USER,
  RECEIVE_ADD_INTERNET_USER,
  ERROR_ADD__INTERNET_USER,
  REQUEST_REMOVE_INTERNET_USER,
  RECEIVE_REMOVE_INTERNET_USER,
  ERROR_REMOVE_INTERNET_USER,
} from "typeConstants";
import api from "apis/underwriter";
import { WebApiReduxRequest, HTTP_GET, HTTP_PUT, HTTP_DELETE } from "tools/webservice";

export const getUnderwriters = (internetUserId) => WebApiReduxRequest(
  REQUEST_GET_UNDERWRITERS,
  RECEIVE_GET_UNDERWRITERS,
  ERROR_GET_UNDERWRITERS,
  HTTP_GET,
  api.getUnderwriters(internetUserId)
);

export const getAuthorizedUnderwriters = (internetUserId) => WebApiReduxRequest(
  REQUEST_GET_AUTHORIZED_UNDERWRITERS,
  RECEIVE_GET_AUTHORIZED_UNDERWRITERS,
  ERROR_GET_AUTHORIZED_UNDERWRITERS,
  HTTP_GET,
  api.getAuthorizedUnderwriters(internetUserId)
);

export const addInternetUser = (underwriterId, internetUserId) => WebApiReduxRequest(
  REQUEST_ADD_INTERNET_USER,
  RECEIVE_ADD_INTERNET_USER,
  ERROR_ADD__INTERNET_USER,
  HTTP_PUT,
  api.addInternetUser(underwriterId, internetUserId)
);

export const removeInternetUser = (underwriterId) => WebApiReduxRequest(
  REQUEST_REMOVE_INTERNET_USER,
  RECEIVE_REMOVE_INTERNET_USER,
  ERROR_REMOVE_INTERNET_USER,
  HTTP_DELETE,
  api.removeInternetUser(underwriterId)
);